<div class="button-container bottom-line">
  @if (permissions.includes("Consultation.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddConsultationDialog()"
      pTooltip="Beratungsgespräch erstellen"
    >
      <span class="button-label"> Beratung</span>
      <img src="../../../assets/Consultation.png" alt="Consultation" />
    </div>
  }

  @if (permissions.includes("Mail.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showSaveEmailDialog()"
      pTooltip="Email ablegen"
    >
      <span class="button-label">E-Mail</span>
      <img src="../../../assets/email-icon.png" alt="E-Mail" />
    </div>
  }

  @if (permissions.includes("Test.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddEignungstestDialog()"
      pTooltip="Eignungstest"
    >
      <span class="button-label">Eignungstest</span>
      <img src="../../../assets/eignungstest.png" alt="Eignungstest" />
    </div>
  }

  @if (permissions.includes("FileUpload.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddIHKEducationDialog()"
      pTooltip="Dokumentenupload"
    >
      <span class="button-label">Dokumentenupload </span>
      <img src="../../../assets/contract.png" alt="IHK/Bildungsgutschein" />
    </div>
  }

  @if (permissions.includes("Contact.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddContactDialog()"
      pTooltip="Kontakt"
    >
      <span class="button-label">Allgemeiner Kontakt</span>
      <img src="../../../assets/Contact.png" alt="Kontakt" />
    </div>
  }

  @if (permissions.includes("Absence.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddAbsenceDialog()"
      pTooltip="Abwesenheit"
    >
      <span class="button-label">Abwesenheit</span>
      <img src="../../../assets/Absent.png" alt="Abwesenheit" />
    </div>
  }

  @if (permissions.includes("Notice.Write")) {
    <div
      class="activity-button small-icon"
      (click)="showAddNoteDialog()"
      pTooltip="Notiz"
    >
      <span class="button-label">Notiz</span>
      <img src="../../../assets/notes.png" alt="Notes" />
    </div>
  }
</div>
